<div>
  <p-panel header="New Authorization Request">
    <div>
      <p>Please review the details of your request below.</p>
      <br />

      <p>
        To complete the request process, please confirm the accuracy of the
        information captured by selecting the checkbox after the request
        details, then hit the 'Submit Authorization' button.
      </p>

      @if (!isPASComplete) {
        <br />
        <p>
          If changes are needed, please select the back button below to return to
          the desired section.
        </p>
      }

      @if (authRequestState) {
        <div>
          <div class="mt-4">
            <authorization-details
              [authData]="authData"
              [isInternal]="isInternal"
              [isPacCommercial]="isPacCommercial"
              [isPASComplete]="isPASComplete"
            ></authorization-details>
          </div>
          <div class="mt-4">
            <diagnosis-details
              [diagnosis]="authRequestState.diagnoses"
              [isPASComplete]="isPASComplete"
            ></diagnosis-details>
          </div>
          <div class="mt-4">
            <servicing-facility
              [servicingFacility]="authRequestState.servicingFacility"
              [tenantName]="tenantName"
              [isInternal]="isInternal"
              [isGoldCardVisible]="isGoldCardVisible"
              [isPASComplete]="isPASComplete"
            ></servicing-facility>
          </div>
          <div class="mt-4">
            <ordering-provider
              [orderingProvider]="authRequestState.orderingProvider"
              [isGoldCardVisible]="isGoldCardVisible"
              [isPASComplete]="isPASComplete"
            ></ordering-provider>
          </div>
          <div class="mt-4">
            <clinical-information-detail
              [tenantId]="tenantId"
              [authorizationType]="authData.facilityType.description"
              [clinicalInformation]="authRequestState.clinicalInformation[authData.facilityType.description]"
              [isPASComplete]="isPASComplete"
            ></clinical-information-detail>
          </div>
          <div class="mt-4">
            <document-details
              [documents]="documentsData"
              [isPASComplete]="isPASComplete"
            ></document-details>
          </div>
        </div>
      }
    </div>
  </p-panel>
  <div class="p-field-checkbox-container pt-6 pb-0">
    <div class="flex items-center">
      <p-checkbox
        inputId="confirmCheckbox"
        data-test-id="confirm-checkbox"
        [(ngModel)]="informationConfirmed"
        [disabled]="isSubmitting"
        [binary]="true"
      ></p-checkbox>
      <label for="confirmCheckbox" class="ml-2">I confirm all information is accurate.</label>
    </div>
  </div>
  <div class="flex justify-between pt-6">
    <div>
      <button
        pButton
        severity="danger"
        aria-label="Cancel Create Authorization"
        label="Cancel"
        icon="pi pi-times"
        type="button"
        data-test-id="cancel-request-button"
        [disabled]="isSubmitting"
        (click)="onCancel()"
      ></button>
    </div>
    <div>
      @if (!isPASComplete) {
        <button
          pButton
          aria-label="Back Step to Documents"
          label="Back"
          icon="pi pi-arrow-left"
          class="p-button-secondary mr-2"
          type="button"
          data-test-id="back-step-button"
          [disabled]="isSubmitting"
          (click)="onClickBack()"
        ></button>
      }
      <button
        pButton
        aria-label="Submit Authorization Request"
        [label]="isAnalyticsEligible ? 'Submit Request' : 'Submit Authorization'"
        icon="pi pi-check"
        type="button"
        data-test-id="submit-button"
        [loading]="isSubmitting"
        [disabled]="!informationConfirmed"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
</div>
